import React, { Component } from 'react';
import { withGoogleMap, GoogleMap, DirectionsRenderer, Marker, InfoWindow, TrafficLayer } from "react-google-maps";
import CustomMarker from './marker';
import PrivadoIcon from '../../img/privadoUbicacion.png';
import { Pulse } from 'react-preloading-component';
import MicroIcon from '../../img/microbus.png'
import CoasterIcon from '../../img/coaster.png'
import PointP from '../../img/pointP.png';
import done from '../../img/done.png';
import wait from '../../img/wait.png';
import './style.css';

const google = window.google;
const pointP = { url: PointP, scaledSize: new google.maps.Size(20, 20) };
const Done = { url: done, scaledSize: new google.maps.Size(20, 20) };
const Wait = { url: wait, scaledSize: new google.maps.Size(20, 20) };
const Privado = { url: PrivadoIcon, scaledSize: new google.maps.Size(30, 35) };
const Microbus = { url: MicroIcon, scaledSize: new google.maps.Size(30, 35) };
const Coaster = { url: CoasterIcon, scaledSize: new google.maps.Size(30, 35) };

const DirectionsService = new google.maps.DirectionsService();


class MapaModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routes: [],
      showTraffic: true
    }
  }

  componentDidMount(){
    this.switchTrafico.checked=true;
  }

  componentDidUpdate(prevProps) {
    let { viajesActivos } = this.props;
    if (viajesActivos !== prevProps.viajesActivos) {
      let datosViajes = [];
      let test = 0
      viajesActivos.forEach(element => {
        if (test <= 9) {
          let ruta = element.rutaViaje;
          if (element.prograDia.pasajeros !== undefined) {
            // Tiene pasajeros - Temporal
            let viaje = this.transformRoutes(ruta, element, false);
            datosViajes.push(viaje)
            // console.log(element.prograDia.pasajeros)
          } else {
            if (ruta.paradas !== undefined) {
              let paradas = ruta.paradas.length;
              if (paradas <= 23) {
                let viaje = this.transformRoutes(ruta, element);
                datosViajes.push(viaje)
              } else {
                let viaje = this.transformRoutes(ruta, element);
                datosViajes.push(viaje)
              }
            } else {
              //Ruta no posee paradas
              let viaje = this.transformRoutes(ruta, element, false);
              datosViajes.push(viaje)
            }
          }
          test++;
        }
      });
      Promise.all(datosViajes).then(routes => {
        // console.log(routes)
        this.setState({ routes })
      })
    }
  }

  transformRoutes = async (ruta, element, parada = true) => {
    let rutaModi = {};
    let paradas = [];
    let paradasAux = [];
    let inicio = ruta.inicio.coordenadas.split(',');
    let destino = ruta.destino.coordenadas.split(',');

    rutaModi.inicio = {
      location: new google.maps.LatLng(inicio[0], inicio[1]),
      name: ruta.inicio.nombre
    }

    rutaModi.destino = {
      location: new google.maps.LatLng(destino[0], destino[1]),
      name: ruta.destino.nombre
    }
    if (parada) {
      ruta.paradas.map(element => {
        let coordparadas = element.coordenadas.split(',');
        paradas.push({
          location: new google.maps.LatLng(coordparadas[0], coordparadas[1]),
          stopover: true
        })
        paradasAux.push({
          location: new google.maps.LatLng(coordparadas[0], coordparadas[1]),
          name: element.referencia
        })
      });

      rutaModi.paradas = paradasAux;
    }
    let valor = ruta.georeferencia === undefined ? [] : ruta.georeferencia;
    if (valor.length === 0) {
      valor.push(await this.getRoute(inicio, destino, paradas, parada))
    }
    rutaModi.georeferencia = valor;
    rutaModi.viaje = element;
    return rutaModi

  }

  getRoute = (inicio, destino, paradas, parada) => {
    let viaje = '';
    viaje = new Promise((resolve, reject) => {
      DirectionsService.route({
        origin: new google.maps.LatLng(inicio[0], inicio[1]),
        destination: new google.maps.LatLng(destino[0], destino[1]),
        waypoints: parada ? paradas : [],
        travelMode: google.maps.TravelMode.DRIVING,
      }, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          resolve(result)
        } else {
          // console.log(status)
          reject(result);
        }
      })
    })

    return viaje;
  }

  onToggleOpenVC = (index, identi) => {
    let { pasado } = this.state;
    let id3 = identi + index;
    if (id3 !== pasado) {
      this.setState({ [id3]: !this.state[id3], [pasado]: false, pasado: id3 });
    }
    else {
      this.setState({ [id3]: !this.state[id3], pasado: id3 });
    }
  }

  switchTraficoHandler = (e)=>{
    this.setState({
      showTraffic:e.target.checked
    })
  }

  render() {
    let { viajesActivos, conductorV, rutaSeleccionada } = this.props;
    let { routes } = this.state;
    return (
      <div>
        <div class="custom-control custom-switch">
          <input type="checkbox" className="custom-control-input" id="traficoSwitch" onChange={this.switchTraficoHandler} ref={el=>this.switchTrafico=el} />
          <label className="custom-control-label" htmlFor="traficoSwitch">Trafico</label>
        </div>
        <GoogleMap
          ref='map'
          defaultZoom={8}
          direccion={{ lat: 13.6842352, lng: -89.2418587 }}
          style={{zIndex: -2, position:'absolute'}}
        >
          {(this.state.showTraffic)? <TrafficLayer autoUpdate /> : null}
          {routes.map((snap, index) => {
            let paradas = snap.paradas !== undefined ? snap.paradas : [];
            let rutas = snap.georeferencia;
            if (rutaSeleccionada.key === undefined) {
              return (
                <div>{
                  rutas.map((snapViaje, index) => {
                    return (
                      <DirectionsRenderer key={'Selec' + index} options={{ polylineOptions: { strokeColor: snap.viaje.rutaViaje.coloRuta }, suppressMarkers: true }} directions={snapViaje} />
                    )
                  })}
                </div>
              )
            }
            else {
              if (rutaSeleccionada.key === snap.viaje.key) {
                return (
                  <div>
                    {rutas.map(snapViaje => {
                      return (
                        <DirectionsRenderer key={'renderSelec' + index} options={{ polylineOptions: { strokeColor: snap.viaje.rutaViaje.coloRuta }, suppressMarkers: true }} directions={snapViaje} />
                      )
                    })}
                    <CustomMarker index={index} visible={this.state['pointsD' + index]} onClick={() => this.onToggleOpenVC(index, 'pointsD')} icon={pointP} location={snap.destino.location} name={'Destino: ' + snap.destino.name} />
                    <CustomMarker index={index} visible={this.state['pointsI' + index]} onClick={() => this.onToggleOpenVC(index, 'pointsI')} icon={pointP} location={snap.inicio.location} name={'Inicio: ' + snap.inicio.name} />
                    {paradas.map((snapP, indexP) => {
                      let checks = snap.viaje.prograDia.checkpoints !== undefined ? snap.viaje.prograDia.checkpoints : [];
                      let isValid = checks.find(check => {
                        return indexP === check.point
                      })
                      if (isValid !== undefined) {
                        return (
                          <CustomMarker index={indexP} visible={this.state['parada' + indexP]} onClick={() => this.onToggleOpenVC(indexP, 'parada')} icon={Done} location={snapP.location} name={snapP.name} />
                        )
                      }
                      return (
                        <CustomMarker index={indexP} visible={this.state['parada' + indexP]} onClick={() => this.onToggleOpenVC(indexP, 'parada')} icon={Wait} location={snapP.location} name={snapP.name} />
                      )
                    })}
                  </div>
                )
              }
              return null;
            }
          })}

          {conductorV.map((snap, index) => {
            if (rutaSeleccionada.key === undefined) {
              return (
                <CustomMarker index={index} visible={this.state['emple' + index]} onClick={() => this.onToggleOpenVC(index, 'emple')} icon={Microbus} location={{ lat: snap.conductor.latitud, lng: snap.conductor.longitud }} name={snap.conductor.nombre} />
              )
            } else {
              if (rutaSeleccionada.key === snap.key) {
                return (
                  <CustomMarker index={index} visible={this.state['emple' + index]} onClick={() => this.onToggleOpenVC(index, 'emple')} icon={Microbus} location={{ lat: snap.conductor.latitud, lng: snap.conductor.longitud }} name={snap.conductor.nombre} />
                )
              }
            }
          })}
        </GoogleMap>
      </div>
    )
  }
}
export default withGoogleMap(MapaModal);


// WEBPACK FOOTER //
// ./src/Components/Rutas/mapaRuta.js